enum HooksModalV5Key {
    SalesSolutionDefault = "SalesSolutionDefault",
    SalesSolutionIntentDefault = "SalesSolutionIntentDefault",
    SalesSolutionRevealDefault = "SalesSolutionRevealDefault",
    SalesSolutionIntentUpsellDefault = "SalesSolutionIntentUpsell",
    RevealContactsPayingUser = "RevealContactsPayingUser", // open this hook for "starter" and "business for investors" users to upgrade their package
    AppLeadGenerator = "AppLeadGenerator",
    LeadEnrichmentApi = "LeadEnrichmentApi",
    OutreachApi = "OutreachApi",
    SalesConversionRate = "SiConversionRate",
    SalesIntelligenceMCP = "SalesIntelligenceMCP",
}

export default HooksModalV5Key;
